import { useEffect, useState } from 'react';

/**
 * false sul primo render (SSR/react-snap + hydration), true dopo mount.
 * Usare per UI dipendente da auth/localStorage: il prerender è sempre "visitatore".
 */
export function useClientMounted() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return mounted;
}
